export const hasAnyTranslations = translations =>
  Object.keys(translations).filter(key => translations[key] !== '').length > 0

export const mapHazardousTranslations = t =>
  ['signalWord', 'warning', 'safetyInstructions', 'additionalCharacteristics', 'productSafety']
    .map(key => ({ [key]: t(`product_hazardous_${key.replace(/([A-Z])/g, '_$1').toLowerCase()}`) }))
    .reduce((acc, curr) => ({ ...acc, ...curr }), {})
